export default __webpack_public_path__ + "f256d9a828699358b36192eb54189b51.svg";